import Vue from 'vue'
import moment from 'moment'
import get from 'lodash/get'
import 'moment-timezone'
import Multiselect from 'vue-multiselect'

import {
	api,
	appData,
	cookies,
	getAppData,
	env,
	events,
	numbers,
	requests,
	urls,
	siteId,
} from '@/utils'

import {
	DatePicker,
} from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

// configure language
locale.use(lang)

Vue.component('multiselect', Multiselect)
Vue.component(DatePicker.name, DatePicker)

events.setPrefix('omWp.')

if (!getAppData('$events')) {
	// One Bus object to rule them all.
	appData.set('$events', events)
}

const localApi = {}
localApi.get = args => localApi.request('get', args)
localApi.post = args => localApi.request('post', args)
localApi.put = args => localApi.request('put', args)
localApi.delete = args => localApi.request('delete', args)
localApi.request = (method = 'get', args) => {
	const req = api.request(method, args)
	if (
		env.isEnv('development') &&
		env.getVar('VUE_APP_AUTH_USER') &&
		env.getVar('VUE_APP_AUTH_PASSWORD')
	) {
		req.auth(env.getVar('VUE_APP_AUTH_USER'), env.getVar('VUE_APP_AUTH_PASSWORD'))
	}

	return req
}

Vue.prototype.$appData         = getAppData
Vue.prototype.$cookies         = cookies
Vue.prototype.$env             = env
Vue.prototype.$events          = events
Vue.prototype.$bus             = new Vue()
Vue.prototype.$moment          = moment
Vue.prototype.$http            = requests
Vue.prototype.$api             = localApi
Vue.prototype.$numbers         = numbers
Vue.prototype.$urls            = urls
Vue.prototype.$siteId          = siteId
Vue.prototype.$get             = function (key, defaultVal) {
	return get(this, key, defaultVal)
}
